<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import SegmentControl from '$lib/components/molecules/segment-control/SegmentControl.svelte';
	import Allowance from '$lib/components/route-details/expense-note/Allowance.svelte';
	import {
		type ComputeMethod,
		getExpenseNoteContext,
	} from '$lib/components/route-details/expense-note/expense-note-context';
	import RealCosts from '$lib/components/route-details/expense-note/RealCosts.svelte';
	import { ROUTE_COSTS } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	const searchParams = getSearchParamsStore();

	const segments = [
		{
			key: 'allowance' as const,
			label: m.route_details__expense_note_section__edit__allowance(),
		},
		{
			key: 'real' as const,
			label: m.route_details__expense_note_section__edit__real(),
		},
	];

	const expenseNote = getExpenseNoteContext();

	let expenseNoteNextValue = { ...$expenseNote };

	function saveFields() {
		$expenseNote = expenseNoteNextValue;
		gotoWithParams(ROUTE_COSTS, { ...$searchParams });
	}

	function handleSegmentChange(segment: ComputeMethod) {
		expenseNoteNextValue.computeMethod = segment;
	}

	function handleBack() {
		gotoWithParams(ROUTE_COSTS, { ...$searchParams });
	}
</script>

<div
	class="fixed md:relative top-0 w-full flex flex-col h-full md:h-auto md:gap-2 z-infront bg-neutral-weakest overflow-y-auto md:overflow-y-initial"
>

	<div class="p-2 md:p-2 md:hidden">
		<div class="flex flex-row h-10">
			<Button
				variant="filled"
				color="light"
				size="md"
				icon="west"
				onclick={handleBack}
				text={m.action__back()}
			/>
		</div>
	</div>
	<div class="px-2 py-4 md:p-2 rd-2 flex flex-col gap-8">
		<div class="font-arvo text-6">{m.route_details__expense_note_section__edit__title()}</div>
		<div class="flex flex-col gap-4">
			<div class="text-sm text-bold">
				{m.route_details__expense_note_section__edit__compute_method()}
			</div>
			<SegmentControl
				options={segments}
				defaultSelectedOption={$expenseNote.computeMethod}
				onSelectOption={computeMethod => handleSegmentChange(computeMethod)}
			/>
			{#if expenseNoteNextValue.computeMethod === 'allowance'}
				<Allowance bind:expenseNote={expenseNoteNextValue} />
			{/if}
			{#if expenseNoteNextValue.computeMethod === 'real'}
				<RealCosts bind:expenseNote={expenseNoteNextValue} />
			{/if}
		</div>

		<Button text={m.action__validate()} color="primary" class="w-fit" onclick={saveFields} />
	</div>
</div>
